import React from 'react';
import { Link } from 'react-router-dom';
import StartButton from '@/components/site/StartButton';
import { usePageMeta } from '@/hooks/usePageMeta';

const NotFound = () => {
  usePageMeta('Page not found');
  return (
    <div className="mx-auto max-w-3xl px-4 py-32 text-center sm:px-6">
      <p className="eyebrow mb-4">404</p>
      <h1 className="mb-6 text-[clamp(2.75rem,5vw,4.5rem)] leading-none">This page doesn’t exist.</h1>
      <p className="body-copy mb-10">It may have moved when the site was updated.</p>
      <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
        <StartButton />
        <Link to="/" className="text-link">
          Back to home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
